"use client"

import Link from "next/link"
import type { ReactNode } from "react"
import type { ContentPage } from "@/cms/service"
import { templateSectionCount } from "@/cms/template-content"
import { localeHref } from "@/i18n/routing"
import styles from "./extra-sections.module.css"
import { CmsText, CmsBody, usePageCanvas } from "./canvas-fields"

export function ExtraSectionsCanvas({ content, bodies }: { content: ContentPage; bodies: ReactNode[] }) {
  const canvas = usePageCanvas()
  if (!content) return null
  const sections = canvas?.sections || content.sections
  return sections.slice(templateSectionCount(content.path)).map((section, index) => <section key={section.id || index} className={styles.section}><div className={styles.narrow}><CmsText as="h2" section={section.id || ""} field="heading" className={styles.smallHeading}>{section.heading}</CmsText><CmsBody section={section.id || ""}>{bodies[index]}</CmsBody>{section.linkHref && section.linkLabel ? <Link className={styles.textLink} href={section.linkHref.startsWith("/") ? localeHref(section.linkHref, content.language) : section.linkHref}><CmsText section={section.id || ""} field="linkLabel">{section.linkLabel}</CmsText></Link> : null}</div></section>)
}
